import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppContext } from '../shared/AppContext';
import { useSPSyncDetailController } from './hooks/useSPSyncDetailController';
import SPSyncDetailView from './components/SPSyncDetailView';

const SPSyncDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const app = useAppContext();
    const ctrl = useSPSyncDetailController(id);

    if (!app.loginUser) {
        return <div></div>;
    }

    if (!ctrl.isSuper) {
        return (
            <div className="container-fluid" style={{ padding: '20px' }}>
                <h4>Access Denied</h4>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return <SPSyncDetailView {...ctrl} />;
};

export default SPSyncDetail;
